var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M42.667 26.667q2.133 0 3.733-1.6t1.6-3.734-1.6-3.733-3.733-1.6-3.734 1.6-1.6 3.733 1.6 3.734 3.734 1.6m-37.334 2.56L29.44 5.333h29.227V34.56L34.773 58.667l-1.493-.214q-1.92-.425-4.053-1.28a41 41 0 0 1-5.974-3.2Q19.627 51.414 16 48q-6.4-6.186-9.173-13.013-1.28-3.414-1.494-5.547zm6.4 3.626q2.347 5.76 8 11.307t11.414 8.107l1.92.64 20.266-20.48v-21.76h-21.76l-20.48 20.48z"
  })));
};
export default SvgTag;